var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-slider{color:#e3e3e3}.custom-dot{position:relative;top:-8px;height:30px!important;width:30px!important;background-color:#acd14d;border-radius:50%;background-image:url(" + escape(require("../../../public/slider.svg")) + ")!important;background-position:50%!important;background-repeat:no-repeat!important;background-size:16px 16px!important}.custom-dot:hover{cursor:pointer}", ""]);

// exports
